function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}
module.exports = _arrayFromIterator;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_arrayFromIterator.js
// module id = 4046
// module chunks = 168707334958949